// src/components/tabs/TabContext.ts
// Which pane a component is rendered in.
//
// A page cannot work this out for itself: its router is pane-local, so the URL
// says nothing about the tab, and several panes are mounted at once. The pane
// hands its id down instead, and everything that files state per tab — entity
// context, page actions — reads it from here.

import { createContext, useContext } from 'react';
import { DETACHED_TAB_ID } from '@/stores/TabsStore';

const TabIdContext = createContext<string>(DETACHED_TAB_ID);

export const TabIdProvider = TabIdContext.Provider;

/** Id of the tab whose pane renders this component. */
export function useTabId(): string {
  return useContext(TabIdContext);
}
